export const FETCH_FARMS_LIST_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/FETCH_FARMS_LIST_REQUEST";
export const FETCH_FARMS_LIST_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/FETCH_FARMS_LIST_SUCCESS";
export const FETCH_FARMS_LIST_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/FETCH_FARMS_LIST_FAILURE";
